import { Controller } from 'react-hook-form'
import FormLabel from '@mui/material/FormLabel'
import { TextFieldProps } from '@mui/material/TextField'

import TextField from './TextField'

type ComponentProps = TextFieldProps & {
  name: string
  control?: any
  label?: unknown
  formLabel?: boolean
}

function ControlledTextField(props: ComponentProps): JSX.Element {
  const { name, control, label, formLabel = false, helperText = '', ...inputProps } = props

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { ref, ...fieldProps }, fieldState }) => (
        <>
          {formLabel && label ? (
            <FormLabel component="legend" error={!!fieldState.error} className="mb-1 text-xs">
              {label}
            </FormLabel>
          ) : null}

          <TextField
            label={!formLabel ? label : null}
            error={!!fieldState.error}
            helperText={fieldState.error?.message ?? helperText}
            {...inputProps}
            {...fieldProps}
            inputRef={ref}
          />
        </>
      )}
    />
  )
}

export default ControlledTextField
